<template>
  <v-btn
      :icon="icon"
      :to="to"
      :disabled="disabled || guardDisabled"
      :href="href"
      :class="textClass"
      :outlined="outlined"
      :small="small"
      :text="text"
      :depressed="depressed"
      :color="color"
      :bold="bold"
      @click="click"
  >
    <v-icon v-if="leftIcon">{{leftIcon}}</v-icon>
    <slot/>
    <v-icon v-if="rightIcon">{{rightIcon}}</v-icon>
  </v-btn>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "TextButton",
    props: {
      "to": String,
      "leftIcon": String,
      "rightIcon": String,
      "icon": Boolean,
      "disabled": Boolean,
      "href": String,
      "primary": Boolean,
      "secondary": Boolean,
      "accent": Boolean,
      outlined: {
        type: Boolean,
        default: false
      },
      "white": Boolean,
      small: {
        type: Boolean,
        default: false
      },
      text: {
        type: Boolean,
        default: true
      },
      depressed: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: undefined,
      },
      bold: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        guardDisabled: false
      }
    },
    computed: {
      textClass () {
        const values = ["text-button"]
        if (this.primary) {
          values.push("primary")
          values.push("white--text")
          return values;
        }
        if (this.secondary) {
          values.push("secondary")
          values.push("white--text")
          return values;
        }
        if (this.accent) {
          values.push("accent")
          values.push("white--text")
          return values;
        }
        if(this.white) {
          values.push("white--text")
          values.push("font-weight-bold")
        } else {
          values.push("primary--text")
        }
        if(this.bold) {
          values.push("font-weight-bold")
        }
        return values;
      }
    },
    methods: {
      click (e) {
        this.$emit("click", e, this.guard)
      },
      guard(process, autoRelease = true) {
        this.guardDisabled = true
        try {
          const release = () => {
            this.guardDisabled = false
          }
          process(release)
        } finally {
          if (autoRelease) {
            this.guardDisabled = false
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
.text-button
  text-transform: none
  border-color: #2f3e6d

.v-btn.text-button.v-btn--outlined.v-btn--text
  text-transform: none
  border-color: #2f3e6d

</style>
